<template>
  <div class="container" :style="{overflow:infoShow == true?'hidden':'auto'}">
    <div class="fixTop">
      <div class="userInfo">
        <img src="../../assets/image/userIcon.jpg" class="icon" @click="clickUserInfo" alt />
        <span class="name">{{userInfo.realname || userInfo.company_name}}</span>
        <span :class="userInfo.is_new_message == 1?'red_circle':''"></span>
        <img src="../../assets/image/xiaoxi.png" @click="myMsg" class="msg" alt />
      </div>
      <div class="title" v-show="userInfo.realname">
        <span class="can_apply" :class="{select: selectType== true}" @click="change(1)">可报名培训课程</span>
        <span class="already_apply" :class="{select: selectType== false}" @click="change(2)">已报名课程管理</span>
      </div>
    </div>

    <!-- 可报名课程 -->
    <!-- <mt-loadmore
      class="content"
      @bottom-status-change="handleTopChange"
      v-show="selectType == true && courseList.length != 0"
      :bottomPullText="''"
      :bottomLoadingText="'加载中'"
      :auto-fill="false"
      :bottom-method="loadBottom"
      :bottom-all-loaded="allLoaded"
      ref="loadmore"
    > -->
    <div class="content" v-show="selectType == true && courseList.length != 0">
      <div
        class="item"
        :style="{backgroundColor:i%2==0?'#d6f7ff':'#faebdc'}"
        v-for="(item,i) in courseList"
        :key="i"
        @click="lookClass(item.id,item.course_name)"
      >
        <div class="item_title">{{item.course_name}}</div>
        <span class="open_class">当前开班数:{{item.plan_count}}</span>
        <button
          class="look_class"
          :style="{backgroundColor:i%2==0?'#3694fa':'#ed9c1d'}"
          @click="lookClass(item.id,item.course_name)"
        >查看班次</button>
      </div>
      <img
        src="../../assets/image/loading.gif"
        v-show="bottomStatus == 'drop'"
        class="showLoading"
        alt
      />
    </div>

      <!-- <div slot="bottom" class="mint-loadmore-bottom" style="display:none"></div>
    </mt-loadmore> -->

    <!-- 已报名课程 -->
    <!-- <mt-loadmore
      class="orther"
      @bottom-status-change="handleTopChange2"
      v-show="selectType== false && signList.length != 0"
      :bottom-method="loadBottom2"
      :auto-fill="false"
      :bottom-all-loaded="allLoaded2"
      ref="loadmore2"
    > -->
    <div class="orther" v-show="selectType== false && signList.length != 0">
      <div class="two_content" v-for="(item,i) in signList" :key="i">
        <div class="top">
          <div class="left">
            <img src="../../assets/image/kecheng@2x.png" alt />
          </div>
          <div class="right">
            <div class="class_title">{{item.course_name}}</div>
            <div class="class_time">8月5日-8月20日</div>
          </div>
        </div>
        <button class="user_applyOrcompany_apply">{{item.is_company_sign == 0?'个人报名':'企业报名'}}</button>
        <div class="Information">
          所属行业:
          <span>{{item.industry_name}}</span>
        </div>
        <div class="Information">
          课程班期:
          <span>{{item.plan.plan_name}}</span>
        </div>
        <div class="Information">
          开班时间:
          <span>{{item.plan.start_time}}</span>
        </div>
        <div class="Information">
          课程介绍:
          <span>{{item.course.desc}}</span>
        </div>
        <div class="Information">
          报名人数:
          <span>{{item.plan.sign_people}}/{{item.plan.limit_people}}</span>
        </div>
        <div class="Information" v-show="item.sign_status == 1">
          未通过原因:
          <span>{{item.remark}}</span>
        </div>
        <!-- <div class="bottom" v-show="item.sign_status == -1">
          <span class="left"></span>
          <span class="right"></span>
        </div>-->
        <!-- <div class="bottom" v-show="item.sign_status == 0 && item.is_company_sign != 1" @click="cancelApply(item.id)">取消报名</div> -->
        <div class="bottom" v-show="item.sign_status == 0 || item.sign_status == 1">
          <span class="left" @click="cancelApply(item)">取消报名</span>
          <span class="right" @click="anewApply(item.id,item.course_id)">上传报名资料</span>
        </div>
        <div class="bottom" v-show="item.sign_status == 2 || item.sign_status == 7">
          <span class="left" @click="cancelApply(item)">取消报名</span>
          <span class="right" @click="payMoney(item.id,item)">去缴费</span>
        </div>
        <div class="bottom" v-show="item.sign_status == 3">
          <span class="left" @click="applyCancel(item.id)">申请退款</span>
          <span class="left2" @click="applyAdjust(item.id,item.course_id)">申请调剂</span>
          <span class="right" v-show="item.invoice_status == -1" @click="applyTicket(item.id)">申请开票</span>
          <span class="right" v-show="item.invoice_status != -1" @click="lookTicket(item.id)">查看发票</span>
        </div>
        <div class="bottom" v-show="item.sign_status == 4" @click="queryGrade(item.id)">查询成绩</div>
        <div class="bottom" v-show="item.sign_status == -1 && item.is_refund == 1" @click="anewApply(item.id,item.course_id)">上传报名资料</div>
        <div class="bottom" v-show="item.sign_status == -1 && item.is_refund == 0" @click="anewApply(item.plan_id,item.course_id)">重新申请报名</div>
        <button class="state" v-show="item.sign_status == -1 && item.is_refund == 1">已退款</button>
        <button class="state" v-show="item.sign_status == -1 && item.is_refund == 0">未退款</button>
        <button class="state" v-show="item.sign_status == 0">待审核</button>
        <button class="state" v-show="item.sign_status == 1">未通过</button>
        <button class="state" v-show="item.sign_status == 2 || item.sign_status == 7">待缴费</button>
        <button class="state" v-show="item.sign_status == 3">已缴费</button>
        <button class="state" v-show="item.sign_status == 4">已结束</button>
      </div>
    </div>

      <!-- <div slot="bottom" class="mint-loadmore-bottom">
        <img
          src="../../assets/image/loading.gif"
          v-show="bottomStatus2 === 'drop'"
          class="showLoading"
          alt
        />
      </div>
    </mt-loadmore> -->
    <!-- <form action="https://www.gnetpg.com/GneteMerchantAPI/api/PayV36" style="display:none" ref="form_pay" v-html="formHtml"></form> -->
    <div
      class="empty"
      v-show="(courseList.length == 0 && selectType == true) || (signList.length == 0 && selectType == false)"
      style="margin-top:100px;"
    >
      <img src="../../assets/image/empty.png" alt />
      <div class="hint">没有发现课程</div>
    </div>
    <!-- 个人信息 -->

    <!-- 企业信息 -->
    <!-- <div class="left_box" v-show="infoShow == true && userInfo.company_name">
      <div class="top">
        <img src="../../assets/image/Wechat.png" class="icon" alt />
        <span class="name">{{userInfo.company_name}}</span>

        <span class="number"><img class="renzheng" src="../../assets/image/renzhneg.png" alt="">{{userInfo.status == 1?'已认证':'待审核'}}</span>
      </div>
      <div class="left_box_info">
        <div class="userData" @click="goCompanyInfo">
          <img src="../../assets/image/qiye@3x.png" alt />
          <span class="text">企业资料</span>
          <i class="iconfont icon-youjiantou"></i>
        </div>
        <div class="userData" @click="myMsg">
          <img src="../../assets/image/xiaoxi@2x.png" alt />
          <span class="text">消息</span>
          <i class="iconfont icon-youjiantou"></i>
        </div>
        <div class="userData" @click="bindStudent">
          <img src="../../assets/image/xueyuan@3x.png" alt />
          <span class="text">绑定的学员</span>
          <i class="iconfont icon-youjiantou"></i>
          <span class="no_bang" style="float:right;font-size:15px;color:#999999;margin-right:10px">{{userInfo.bind_student_num}}人</span>
        </div>
        <div class="userData" @click="updatePwd(1)">
          <img src="../../assets/image/xiugai@2x.png" alt />
          <span class="text">修改密码</span>
          <i class="iconfont icon-youjiantou"></i>
        </div>
      </div>
      <div class="login_out">
          <img src="../../assets/image/out@2x.png" alt="">
          <span class="out">退出登录</span>
      </div>
    </div>-->
    <div class="mask" v-show="infoShow == true" @click="infoShow = false"></div>
    <!--个人信息 -->
    <van-popup
      position="left"
      class="left_box"
      v-model="infoShow"
      v-show="infoShow == true"
      :overlay="false"
    >
      <div class="top">
        <img src="../../assets/image/userIcon.jpg" class="icon" alt />
        <span class="name">{{userInfo.realname}}</span>
        <span class="number">{{userInfo.is_sign == 0?'未报名课程':'已报名课程'}}</span>
      </div>
      <div class="left_box_info">
        <div class="userData" @click="gouserInfo">
          <img src="../../assets/image/geren@2x.png" alt />
          <span class="text">个人资料</span>
          <i class="iconfont icon-youjiantou"></i>
        </div>
        <div class="userData otherUserData" @click="myMsg">
          <img src="../../assets/image/xiaoxi@2x.png" alt />
          <span class="text">我的消息</span>
          <span class="redCircle" v-show="userInfo.is_new_message == 1"></span>
          <i class="iconfont icon-youjiantou"></i>
        </div>
        <div class="userData" @click="goCompany()">
          <img src="../../assets/image/bangding@2x.png" alt />
          <span class="text">企业绑定</span>
          <i class="iconfont icon-youjiantou"></i>
          <span
            class="no_bang"
            style="float:right;font-size:15px;color:#999999;margin-right:10px"
          >{{userInfo.company_id == 0?'未绑定':'已绑定'}}</span>
        </div>
        <div class="userData" @click="updatePwd(0)">
          <img src="../../assets/image/xiugai@2x.png" alt />
          <span class="text">修改密码</span>
          <i class="iconfont icon-youjiantou"></i>
        </div>
        <div class="userData" @click="updatePhone()">
          <img src="../../assets/image/updatePhone.png" alt />
          <span class="text">修改手机号</span>
          <i class="iconfont icon-youjiantou"></i>
        </div>
      </div>
      <div class="login_out" @click="loginOut">
        <img src="../../assets/image/out@2x.png" alt />
        <span class="out">退出登录</span>
      </div>
    </van-popup>
  </div>
</template>

<script>
import moment from "moment"; //解析时间戳
// import axios from "axios";
// import {PaySecond} from "../../util/form"
import { Dialog } from "vant";
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    //这里存放数据
    return {
      token: "",
      selectType: true,
      infoShow: false,
      courseList: [], //可报名培训课程
      signList: [], //已报名课程管理
      userInfo: {}, //用户信息或者企业信息

      // page: 1, //可报名的分页
      // per_page: 4, //可报名的分页条数
      // page2: 1, //已报名的分页
      // per_page2: 2, //已报名的分页条数
      allLoaded: false, //true的话就不触发
      allLoaded2: false, //true的话就不触发
      bottomStatus: "",
      bottomStatus2: "",
      showLeftBox: false,

      formHtml: "",
      formData: {
        SignMsg: "",
        OrderNo: "",
        MerId: "",
        OrderAmount: "",
        CallBackUrl: "",
        CurrCode: "",
        OrderType: "",
        BankCode: "",
        LangType: "",
        BuzType: ""
      },
      code: "",
      cancelId: [] //取消报名的ID记录下来
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    showPopup() {
      this.show = true;
    },
    handleTopChange(status) {
      this.bottomStatus = status;
    },
    handleTopChange2(status) {
      this.bottomStatus2 = status;
    },
    loadBottom() {
      // 加载更多数据
      this.page++;
      this.getCourseList();
      this.$refs.loadmore.onBottomLoaded();
    },
    loadBottom2() {
      // 加载更多数据
      this.page2++;
      this.getSignList();
      this.$refs.loadmore2.onBottomLoaded();
    },
    // 可报名    已报名    切换
    change(index) {
      if (index == 1) {
        this.selectType = true;
        this.allLoaded = false;
        this.getCourseList();
      } else {
        this.selectType = false;
        this.allLoaded2 = false;
        this.getSignList();
      }
    },
    // 查询成绩
    // query() {
    //   this.$router.push({ path: "/queryScore" });
    // },
    // 点击弹出个人信息
    clickUserInfo() {
      this.infoShow = true;
    },
    // 重新报名
    anewApply(plan_id,course_id) {
      this.$router.push({ path: "/applyForm", query: { id: plan_id,course_id:course_id }});
    },
    // 去个人资料
    gouserInfo() {
      this.$router.push({ path: "/userInfo" }); //个人资料
    },
    // 去我的消息
    myMsg() {
      // e=1就是企业消息    e=0就是个人消息
      this.$router.push({ name: "myMessage" });
    },
    // 企业绑定
    goCompany() {
      if (this.userInfo.company_id == 0) {
        // 未绑定
        this.$router.push({ path: "/company" });
      } else {
        // 已绑定
        this.$router.push({ path: "/uCompanyList" }); //已绑定
      }
    },
    // 绑定的学员
    bindStudent() {
      this.$router.push({ path: "/city" });
    },
    // 去修改密码
    updatePwd(e) {
      if (e == 0) {
        this.$router.push({
          path: "/updatePwd",
          query: { phone: this.userInfo.phone }
        }); //个人修改密码
      } else {
        this.$router.push({ path: "/updateCompanyPwd" }); //企业修改密码
      }
    },
    // 去修改手机号
    updatePhone() {
      this.$router.push({ path: "/updatePhone" });
    },
    // 去企业资料
    goCompanyInfo() {
      this.$router.push({ path: "/companyInfo" }); //企业资料
    },
    // 查看班次
    lookClass(e, course_name) {
      this.$router.push({ path: "classList", query: { id: e, course_name } });
    },
    sumbit() {
    },
    // 获取个人信息
    getUserInfo() {
      this.$http.getUserInfo({}).then(res => {
        if (res.status == 1) {
          this.userInfo = res.data;
        } else {
          this.$hide.alert({
            message: res.msg
          });
        }
      });
    },
    // 获取可报名培训课程列表
    getCourseList() {
      this.$toast.loading({ message: "加载中" });
      this.$http
        .getCourseNewList({
          page: this.page,
          per_page: this.per_page,
          wx_code: this.code,
          type:"mobile"
        })
        .then(res => {
          this.$toast.clear();
          if (res.status == 1) {
            let list = res.data.data;
            this.courseList = list;
            // if (list == null || list.length == 0) {
            //   // 加载结束
            //   this.allLoaded = true; // 若数据已全部获取完毕
            //   return;
            // }
            // if (list.length < 4) {
            //   // 最后一页不足10条的情况
            //   this.allLoaded = true; // 若数据已全部获取完毕
            // }
            // if (this.page == 1) {
            //   this.courseList = list;
            // } else {
            //   this.courseList = this.courseList.concat(list);
            //   //this.isUpLoading = false
            // }
          } else {
            this.$hide.alert({
              message: res.msg
            });
          }
        });
    },
    //学员获取已报名课程列表
    getSignList() {
      this.$toast.loading({
        mask: false,
        message: "加载中"
      });
      this.$http
        .studentGetSignList({
          page: this.page2,
          per_page: this.per_page2,
        })
        .then(res => {
          this.$toast.clear();
          if (res.status == 1) {
            let list = res.data.data;
            for (let index = 0; index < list.length; index++) {
              if (list[index].plan.course_begin_time) {
                list[index].plan.start_time = moment(
                  list[index].plan.course_begin_time * 1000
                ).format("YYYY-MM-DD HH:mm:ss");
              }
              if (list[index].plan.course_end_time) {
                list[index].plan.end_time = moment(
                  list[index].plan.course_end_time * 1000
                ).format("YYYY-MM-DD HH:mm:ss");
              }
            }
            this.signList = list
            // if (list == null || list.length == 0) {
            //   // 加载结束
            //   this.allLoaded2 = true; // 若数据已全部获取完毕
            //   // this.signList = list
            //   return;
            // }
            // if (list.length < 4) {
            //   // 最后一页不足10条的情况
            //   this.allLoaded2 = true; // 若数据已全部获取完毕
            // }
            // if (this.page2 == 1) {
            //   this.signList = list;
            // } else {
            //   this.signList = this.signList.concat(list);
            //   // this.isUpLoading = false
            // }
          }
        });
    },
    // 取消报名
    cancelApply(item) {
      Dialog.confirm({
        title: "标题",
        message: "确定取消本期课程的报名吗?"
      })
        .then(() => {
          this.$http
            .studentCancelSign({
              sign_id: item.id,
              wx_code: this.code
            })
            .then(res => {
              if (res.status == 1) {
                this.cancelId.push({
                  id: item.id,
                  courseId: item.course_id
                });
                let cancelIdList = JSON.parse(localStorage.getItem("courseId"));
                if (cancelIdList) {
                  cancelIdList.push({
                    id: item.id,
                    courseId: item.course_id
                  });
                  localStorage.setItem(
                    "courseId",
                    JSON.stringify(cancelIdList)
                  );
                } else {
                  localStorage.setItem(
                    "courseId",
                    JSON.stringify(this.cancelId)
                  );
                }

                this.$hide
                  .alert({
                    message: res.msg
                  })
                  .then(() => {
                    for (let index = 0; index < this.signList.length; index++) {
                      if (item.id == this.signList[index].id) {
                        this.signList.splice(index, 1);
                      }
                    }
                    this.page2 = 1;
                    this.allLoaded2 = false;
                    this.getSignList();
                  });
              } else {
                this.$hide.alert({
                  message: res.msg
                });
              }
            });
        })
        .catch(() => {
        });
    },
    // 申请调剂
    applyAdjust(id) {
      Dialog.confirm({
        title: "提示",
        message: "工作人员将为您调剂到同类培训 课程的其他班次?"
      })
        .then(() => {
          this.$http
            .studentApplyChange({
              sign_id: id
            })
            .then(res => {
              if (res.status == 1) {
                this.$hide.alert({
                  message: res.msg
                });
              } else {
                this.$hide.alert({
                  message: res.msg
                });
              }
            });
        })
        .catch(() => {
        });
    },
    // 申请开票
    applyTicket(id){
      // this.$router.push({ path: "/applyTicket" });
      this.$router.push({ path: "/applyTicket", query: { id: id } });
    },
    // 查看发票
    lookTicket(id){
      this.$router.push({ path: "/ticketDetail", query: { id: id } });
    },
    // 去缴费
    payMoney(id) {
      const _this = this
      this.$toast.loading({
        mask: true,
        message: "加载中"
      });
      this.$http
        .wechartPay({
          sign_id: id,
        })
        .then(res => {
          this.$toast.clear();
          if (res.status == 1) {
            WeixinJSBridge.invoke(
              "getBrandWCPayRequest",
              {
                appId: res.data.appId, //公众号名称，由商户传入
                timeStamp: res.data.timeStamp, //时间戳，自1970年以来的秒数
                nonceStr: res.data.nonceStr, //随机串
                package: res.data.package,
                signType: res.data.signType, //微信签名方式：
                paySign: res.data.paySign //微信签名
              },
              function(res1) {
                if (res1.err_msg == "get_brand_wcpay_request:ok") {
                  // 使用以上方式判断前端返回,微信团队郑重提示：
                  //res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
                  Dialog.confirm({
                    title: "标题",
                    message:"根据国家税务要求，报名缴费需进行开票，请尽快提交发票申请",
                    cancelButtonText:"暂不申请",
                    confirmButtonText:"确认申请",
                  }).then(()=>{
                    _this.$router.push({ path: "/applyTicket", query: { id: id } });
                  })

                }
              }
            );
          } else {
            this.$hide.alert({
              message: res.msg
            });
          }
        });
    },
    // 上传报名资料
    uploadingFile(item) {
      this.$router.push({
        name: "uploadingApplyData",
        query: { id: item.plan_id, from: 1, course_id: item.course_id }
      });
    },
    // 退出登录
    loginOut() {
      localStorage.removeItem("token");
      localStorage.removeItem("courseId");
      this.$router.push({ path: "/login" });
    },
    // 查询成绩
    queryGrade(id) {
      this.$router.push({ path: "/queryScore", query: { id: id } });
    },
    // 申请取消报名
    applyCancel(id) {
      this.$http
        .applyCancelSign({
          sign_id: id
        })
        .then(res => {
          if (res.status == 1) {
            this.$hide
              .alert({
                message: res.msg
              })
              .then(() => {
                this.getSignList();
              });
          } else {
            this.$hide.alert({
              message: res.msg
            });
          }
        });
    }
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    let showLeftBox = localStorage.getItem("leftBox");

    if (showLeftBox == "true") {
      this.showLeftBox = true;
      this.infoShow = true;
    } else {
      this.infoShow = false;
    }
    if (location.href != "https://www.jspx0769.com/wx/#/"){
      // 获取code
      let str = location.href,
      num = str.indexOf("?");
      str = str.substr(num + 1);
      let arr = str.split("&");
      // var code = arr[1].split("=")[1];
      var moneys = arr[0].split("=")[1];
      this.code = moneys;
    }

    this.getUserInfo();
    this.getCourseList();
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {} //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang='less' scoped>
//@import url(); 引入公共css类
@import url("../../assets/css/all.css");
.container {
  background-color: #f5f5f5;
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
  .fixTop{
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    z-index: 99;
  }
  .userInfo {
    width: 100%;
    padding: 10px 20px;
    background-color: #fff;
    box-sizing: border-box;
    .icon {
      width: 45px;
      height: 45px;
      vertical-align: middle;
      border-radius: 50%;
    }
    .name {
      font-size: 22px;
      vertical-align: middle;
      margin-left: 10px;
    }
    .msg {
      width: 40px;
      height: 40px;
      float: right;
      margin-top: 5px;
    }
    .red_circle {
      display: inline-block;
      width: 5px;
      height: 5px;
      border-radius: 50%;
      background-color: red;
      position: absolute;
      right: 30px;
      top: 23px;
    }
  }
  .title {
    width: 100%;
    display: flex;
    height: 41px;
    box-sizing: border-box;
    background-color: #fff;
    // margin-top: 2px;
    border-top: 1px solid #f5f5f5;
    line-height: 41px;
    z-index: 10;
    .can_apply {
      border-right: 1px solid #dddddd;
    }
    .can_apply,
    .already_apply {
      height: 100%;
      flex: 1;
      color: #7a7a7a;
      text-align: center;
      font-size: 16px;
    }
    .select {
      color: #333333;
    }
  }
  .content {
    width: 100%;
    background-color: #fff;
    // overflow: hidden;
    margin-top: 114px;
    // min-height: calc(100% + 1px);
    height: 81% !important;
    position: relative;
    overflow-x: hidden;
	overflow-y: auto;
	-webkit-overflow-scrolling: touch;
    .item {
      width: 90%;
      margin: 10px auto;
      background-color: #d6f7ff;
      padding: 12px 15px;
      box-sizing: border-box;
      border-radius: 5px;
      .item_title {
        font-size: 19px;
        color: #498dfe;
      }
      .open_class {
        font-size: 15px;
        color: #666666;
        margin-top: 25px;
        display: inline-block;
      }
      .look_class {
        // width: 68px;
        // height: 26px;
        // line-height: 26px;
        padding: 6px 10px;
        box-sizing: border-box;
        font-size: 13px;
        color: #fff;
        background-color: #3695fa;
        border: none;
        border-radius: 5px;
        float: right;
        margin-top: 20px;
      }
    }
  }
  .two_content {
    padding: 14px 16px;
    box-sizing: border-box;
    background-color: #fff;
    width: 92%;
    overflow: hidden;
    margin: 5px auto 0;
    border-radius: 8px;
    position: relative;
    margin-bottom: 10px;
    .top {
      // height: 42px;
      margin-bottom: 20px;
      .left {
        height: 100%;
        display: inline-block;
        vertical-align: middle;
        img {
          width: 42px;
          height: 42px;
        }
      }
      .right {
        display: inline-block;
        margin-left: 13px;
        vertical-align: middle;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        vertical-align: middle;
        width: 60%;
        // height: 100%;
        .class_title {
          font-size: 17px;
          color: #333333;
          width: 100%;
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
        }
        .class_time {
          font-size: 14px;
          color: #999999;
          margin-top: 0px;
        }
      }
    }
    .user_applyOrcompany_apply {
      position: absolute;
      right: 15px;
      top: 20px;
      font-size: 12px;
      color: #ddd;
      background-color: #fff;
      border: 1px solid #ddd;
      border-radius: 12px;
    }
    .Information {
      color: #666666;
      font-size: 15px;
      line-height: 25px;
      span {
        color: #333333;
      }
    }
    .bottom {
      color: #ff862d;
      font-size: 16px;
      text-align: center;
      border-top: 1px solid #eaeaea;
      margin-top: 10px;
      padding-top: 10px;
      display: flex;
      align-items: center;
      justify-content: center;
      .left {
        flex: 1;
        border-right: 1px solid #eaeaea;
      }
      .left2{
        flex: 1;
        color: #377dff;
        border-right: 1px solid #eaeaea;
      }
      .right {
        flex: 1;
        color: #377dff;
      }
      .button {
        border: none;
        background-color: #fff;
      }
    }
    .state {
      position: absolute;
      width: 75px;
      height: 28px;
      background-color: #377dff;
      color: #fff;
      border-radius: 14px;
      border: none;
      bottom: 55px;
      right: 15px;
      font-size: 15px;
    }
  }
  .orther {
    width: 100%;
    margin-top: 114px;
    height: 81% !important;
    position: relative;
    overflow-x: hidden;
    overflow-y: auto;
  }
  .left_box {
    height: 100%;
    background-color: #ffffff;
    width: 85%;
    z-index: 10;
    overflow: hidden;
    .top {
      width: 100%;
      height: 22%;
      background: url("../../assets/image/bj@2x.png");
      background-size: 100% 100%;
      background-repeat: no-repeat;
    }
    .renzheng {
      width: 12px;
      height: 14px;
      // position: absolute;
      // top: 85px;
      // left: 111px;
      margin-right: 5px;
    }
    .icon {
      position: absolute;
      width: 68px;
      height: 68px;
      top: 41px;
      left: 25px;
      border-radius: 50%;
    }
    .name {
      font-size: 18px;
      color: #333333;
      position: absolute;
      top: 50px;
      left: 111px;
    }
    .number {
      font-size: 15px;
      color: #666666;
      position: absolute;
      top: 84px;
      left: 111px;
    }
    .left_box_info {
      height: 100%;
      width: 100%;
      padding: 34px 16px 0 26px;
      box-sizing: border-box;
      .userData {
        height: 50px;
        line-height: 50px;
        img {
          width: 20px;
          height: 19px;
          vertical-align: middle;
        }
        .text {
          font-size: 16px;
          color: #333333;
          vertical-align: middle;
          margin-left: 15px;
        }
        .iconfont {
          float: right;
        }
      }
      .otherUserData {
        position: relative;
        .redCircle {
          width: 5px;
          height: 5px;
          background-color: red;
          border-radius: 50%;
          position: absolute;
          top: 15px;
        }
      }
    }
    .login_out {
      width: 100%;
      position: fixed;
      bottom: 0;
      left: 0;
      height: 42px;
      line-height: 42px;
      text-align: center;
      border-top: 1px solid #dddddd;
      img {
        width: 16px;
        height: 16px;
        vertical-align: middle;
      }
      .out {
        font-size: 17px;
        color: #333333;
        vertical-align: middle;
        margin-left: 12px;
      }
    }
  }
  .mask {
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
    background: rgba(0, 0, 0, 0.4);
    z-index: 9;
  }
  .showLoading {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
  }
  .mint-loadmore {
    // overflow: scroll;
    // height: 500px !important;
    height: auto;
    margin-top: 114px;
  }
}
</style>
<style >
.mint-loadmore-content {
  height: auto !important;
  /* overflow-y: auto; */
  /* -webkit-overflow-scrolling: touch; */
}
.container .showLoading {
  bottom: -30px;
}
</style>
